import React, { useContext } from "react";
import { Grid2, Typography, useMediaQuery } from "@mui/material";
import Fallback_UI_Img from "../../assets/images/FallbackUIImage.png";
import "./FallbackUI.style.css";
import AppButton from "../CommonReusableComponent/AppButton/AppButton";
import { useNavigate } from "react-router-dom";
import { AppGlobalContext } from "../../contexts/AppContext.context";
import { firebaseLogOut } from "../../services/authServices/auth.services";

const FallbackUIForAccountNotAssigned = () => {
  const navigate = useNavigate();
  const { SetAppState } = useContext(AppGlobalContext);
  const isMobile = useMediaQuery("(max-width:600px)");

  const handleUserLogout = () => {
    firebaseLogOut();
    SetAppState({
      isAuthUser: false,
      loggedInUserRole: false,
      responsibilities: null,
      authUserDetails: {},
    });
    localStorage.clear();
    navigate("/", {
      replace: true,
    });
    window.history.pushState(null, "", "/");
  };

  return (
    <React.Fragment>
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ height: "90vh" }}
      >
        <Grid2 container justifyContent={"center"}>
          <Grid2 size={{ xs: 12 }}>
            <div className="fallback-img-container">
              <img
                src={Fallback_UI_Img}
                alt="fallback-ui"
                className="fallback-img"
              />
            </div>
          </Grid2>
          <Grid2 size={{ xs: 12 }}>
            <div className="text-center my-2 mb-3">
              <Typography
                style={{
                  fontSize: isMobile ? "20px" : "23px",
                }}
                className="inter-medium-500"
              >
                No Account Assigned
              </Typography>
            </div>
            <div className="m-2 text-center px-2">
              <Typography
                variant={isMobile ? "body2" : "body1"}
                className="inter-regular-400"
              >
                You are not assigned to any account at the moment.
              </Typography>
              <Typography
                variant={isMobile ? "body2" : "body1"}
                className="inter-regular-400"
              >
                Please log out and kindly contact your administrator for
                assistance.
              </Typography>
            </div>
          </Grid2>
          <Grid2 size={{ xs: 8, sm: 3, md: 2 }}>
            <div className="m-2 px-2">
              <AppButton OnPress={handleUserLogout}>Log Out</AppButton>
            </div>
          </Grid2>
        </Grid2>
      </div>
    </React.Fragment>
  );
};

export default FallbackUIForAccountNotAssigned;
